import { render, staticRenderFns } from "./last-record-ref.vue?vue&type=template&id=f05c6f36&scoped=true&"
import script from "./last-record-ref.vue?vue&type=script&lang=js&"
export * from "./last-record-ref.vue?vue&type=script&lang=js&"
import style0 from "./last-record-ref.vue?vue&type=style&index=0&id=f05c6f36&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05c6f36",
  null
  
)

export default component.exports